import { hasPermissionTo, PERMISSIONS } from 'src/utils/permissions'

export const TRACKING_EDITOR_ROLES = {
  FORWARDER: 'forwarder',
  CARRIER: 'carrier'
}

export const getTrackingEditorRole = ({
  trackingItem,
  currentUserId,
  currentUserCompanyId,
  permissions
}) => {
  if (!trackingItem?.isEditable) {
    return null
  }

  if (trackingItem.forwarderUserId === currentUserId) {
    return TRACKING_EDITOR_ROLES.FORWARDER
  }

  if (trackingItem.carrierUserId === currentUserId) {
    return TRACKING_EDITOR_ROLES.CARRIER
  }

  if (!hasPermissionTo(PERMISSIONS.RESERVATION_ACCEPT_ANY, permissions)) {
    return null
  }

  if (
    currentUserCompanyId &&
    trackingItem.forwarderUser?.company?.id === currentUserCompanyId
  ) {
    return TRACKING_EDITOR_ROLES.FORWARDER
  }

  if (
    currentUserCompanyId &&
    trackingItem.carrierUser?.company?.id === currentUserCompanyId
  ) {
    return TRACKING_EDITOR_ROLES.CARRIER
  }

  return null
}

export const isTrackingEditorForwarder = args =>
  getTrackingEditorRole(args) === TRACKING_EDITOR_ROLES.FORWARDER
